// extracted by mini-css-extract-plugin
export default {"carouselContainer":"productSlider_carouselContainer__QlIxB","sliderRightButton":"productSlider_sliderRightButton__VdVGc"};